var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-layout-content',{attrs:{"is-footer-shown":_vm.isFooterShown}},[_c('main-content-wrapper',[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_vm._t("default")],2)],1),(_vm.isFooterShown)?_c('footer-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }